import React, { useEffect } from "react";
import TopHeader from "../pages/events/single event details/components/TopHeader";
import { Outlet, useLocation, useParams } from "react-router-dom";
import httpServices from "../services/httpServices";

const EventLayout = () => {
  const path = useLocation();
  const { id } = useParams() || "";
  const [eventData, setEventData] = React.useState();

  const getEventDetails = async () => {
    try {
      const { response } = await httpServices.get(`/event/details/${id}`, {
        skip: !id,
      });

      if (response.status === 200) {
        console.log("Response from eventLayout", response.data?.data);
        setEventData(response.data?.data);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    if (id) {
      getEventDetails();
    }
  }, [id]);

  return path.pathname === "/events" ||
    path.pathname === `/events/${id}` ||
    path.pathname === "/events/add-events" ? (
    <>
      <Outlet />
    </>
  ) : (
    <div className="w-full min-h-[965px] xs:!p-[16px] !p-[10px] bg-white rounded-[10px] my-[16px] gap-[16px]">
      <TopHeader data={eventData} />
      <Outlet />
    </div>
  );
};

export default EventLayout;
